import {useNavigate, useParams} from "react-router-dom";
import {useForm} from "react-hook-form";
import React, {useState, useEffect, useContext} from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  HStack,
  VStack,
  Checkbox,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input, Divider,
  Textarea, Alert, AlertIcon, AlertTitle,
  useDisclosure,
  Container,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter,
} from '@chakra-ui/react';
import ReactPaginate from "react-paginate";

import {client} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";
import {User} from "@/pbgen/v1/main_pb"
import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"

import './ListForm.css';

export const Admins = () => {
  const [users, setUsers] = useState<User[]>([]);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(users.length / itemsPerPage);
  const [itemsOffset, setItemsOffset] = useState(0);
  const endOffset = itemsOffset + itemsPerPage
  const currentUsers = users.slice(itemsOffset, endOffset);
  const {globalState, setGlobalState} = useContext(GlobalContext);
  const navigate = useNavigate();
  useEffect(() => {(async () => {
    const resp = await client.getAdmins({
      bearerToken: bearerToken(),
    }).catch(() => undefined);
    if (! resp) {
      console.log("Failed to get admins");
      return;
    }
    setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})
    if (! resp.currentUser) {
      navigate("/login", { relative: "path" });
      return;
    }
    setUsers(resp.admins);
  })();}, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageClick = (e: { selected: number }) => {
    const newOffset = (e.selected * itemsPerPage);
    setItemsOffset(newOffset);
  }

  return <Page>
    <PageHeader title={"管理者一覧"}>
      <HStack padding={2}>
        <Button onClick={() => {navigate("./new", { relative: "path" })}}>新規追加</Button>
        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>
      </HStack>
    </PageHeader>
    <PageBody>
      <VStack>
        <Table className="list_table">
          <Thead>
            <Tr>
              <Th width={'10em'}>ID</Th>
              <Th>管理者名</Th>
              <Th width={'10em'}>編集</Th>
            </Tr>
          </Thead>
          <Tbody>
          {
            currentUsers.map((admin) => <Tr key={admin.id}>
              <Td>{admin.id}</Td>
              <Td style={{ textAlign: "left" }}><span className="list_table_name" >{admin.optName ?? ""}</span></Td>
              <Td><Button onClick={() => {navigate(`./${admin.id}`, {relative: "path"})}}>編集</Button></Td>
            </Tr>)
          }
          {
            [...Array(itemsPerPage - currentUsers.length)].map((_, i) => (
              <Tr key={`dummy-${i}`}>
              <Td>—</Td>
              <Td>—</Td>
              <Td><Button isDisabled={true}>編集</Button></Td>
            </Tr>))
          }
          </Tbody>
        </Table>
        {/*<ReactPaginate pageCount={pageCount} onClick={handlePageClick} />*/}
        <ReactPaginate 
          previousLabel="前へ"
          nextLabel="次へ"
          breakLabel="..."
          pageCount={pageCount} onPageChange={handlePageClick} className={'react-paginate'} />
      </VStack>
    </PageBody>
  </Page>
}


type FormData = {
  id: string;
  password: string;
  name: string;
  namePronunciation: string;
  note: string;
};

export const Admin = () => {
  const [formError, setFormError] = useState('');
  const {
    register: registerElement,
    handleSubmit: wrapSubmitHandlerWithFormValidator,
    formState: { errors: formErrors },
    setValue,
  } = useForm<FormData>();
  const { globalState, setGlobalState } = useContext(GlobalContext);
  const navigate = useNavigate();
  const { aid: id } = useParams();
  const { isOpen: isErrorOpen, onOpen: onErrorOpen, onClose: onErrorClose } = useDisclosure()
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure()
  const cancelDeleteRef = React.useRef<HTMLButtonElement | null>(null)
  const [showPassword, setShowPassword] = useState(false);
  const { isOpen: isFinishOpen, onOpen: onFinishOpen, onClose: onFinishClose } = useDisclosure()

  useEffect(() => {
    (async () => {
      if (id === "new") {
        return;
      }
      const resp = await client.getUser({
        bearerToken: bearerToken(),
        id: id,
      });
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})
      if (! resp.currentUser) {
        navigate("/login", { relative: "path" });
        return;
      }
      if (! resp.user) {
        navigate("..", { relative: "path" });
        return;
      }
      setValue("id", resp.user.id);
      setValue("password", "");
      setValue("name", resp.user.optName ?? "");
      setValue("namePronunciation", resp.user.optNamePronunciation ?? "");
      setValue("note", resp.user.optNote ?? "");
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  if (! id) {
    navigate("..", { relative: "path" });
    return <></>;
  }

  const handleOk = () => {
    navigate(-1);
  };

  const submitIfValid = wrapSubmitHandlerWithFormValidator(async (data) => {
    console.log(data)

    const user = new User({
      id: data.id,
      optPassword: data.password,
      optRole: "admin",
      optName: data.name,
      optNamePronunciation: data.namePronunciation,
      optNote: data.note,
    })

    const resp = await client.saveUser({
      bearerToken: bearerToken(),
      user: user,
      newUser: ("new" === id),
    });

    if (resp.error) {
      setFormError(resp.error.message);
      onErrorOpen();
      return;
    } else {
      onFinishOpen();
    }

    if (id === "new") {
      // History replace navigation // useNavigate v6.22.2 | React Router https://reactrouter.com/en/main/hooks/use-navigate
      navigate(`../${data.id}`, { relative: "path", replace: true })
    }
  });
  return <Page>
    <PageHeader title={("new" === id)? "管理者新規登録": "管理者編集"}>
      <HStack padding={2}>

        <Button onClick={submitIfValid}>{("new" === id)? "登録": "保存"}</Button>

        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>

        <AlertDialog isOpen={isDeleteOpen} onClose={onDeleteClose} leastDestructiveRef={cancelDeleteRef}>
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader>
                管理者の削除
              </AlertDialogHeader>
              <AlertDialogBody>
                管理者「{id}」を本当に削除しますか？
              </AlertDialogBody>
              <AlertDialogFooter>
                <Button ref={cancelDeleteRef} onClick={onDeleteClose}>
                  キャンセル
                </Button>
                <Button  ml={3} onClick={async () => {
                    const resp = await client.deleteUser({
                    bearerToken: bearerToken(),
                    id,
                });
                if (resp.error) {
                  setFormError(resp.error.message);
                  onErrorOpen();
                  return;
                }
                navigate("..", { relative: "path", replace: true})
                }}>削除</Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        {("new" !== id) ? 
          <Button onClick={async () => {onDeleteOpen()}}>削除</Button>
        : null }

      </HStack>
    </PageHeader>

    <PageBody>
      <VStack className="edit_form" spacing={4} align="start">

        <HStack>
          {(id === "new") ? (
            <>
            <FormControl isInvalid={Boolean(formErrors.id)} isRequired={("new" === id)}>
              <FormLabel><span>ID</span></FormLabel>
              <Input className="edit_form_short" type="number" autoComplete={"off"} {...registerElement("id", {
                required: "IDは必須項目です。",
                pattern: {
                  value: /^[0-9]{8}$/,
                  message: "８桁の半角数字を入力してください。",
                },
              })} />
              <FormErrorMessage>{ formErrors.id?.message }</FormErrorMessage>
            </FormControl>
            <FormControl >
              <div className="edit_form_summary">
                IDを８桁の半角数字で入力してください。
              </div>
            </FormControl>
            </>
          )
          : (
            <>
            <FormControl isInvalid={Boolean(formErrors.id)}>
              <FormLabel><span>ID</span></FormLabel>
              <Input className="edit_form_short" isDisabled={true} autoComplete={"off"} {...registerElement("id", {})} />
              <FormErrorMessage>{ formErrors.id?.message }</FormErrorMessage>
            </FormControl>
            </>
          )}
        </HStack>

        <HStack>
        {
          ("new" === id) ? (
            <>
            <VStack align="flex-start">
              <FormControl isInvalid={Boolean(formErrors.password)} isRequired>
                <FormLabel 
                  requiredIndicator = {
                    <span style={{ color: "white", fontSize: "70%", backgroundColor:"#df6694", marginLeft: "4px",}}>✱必須項目</span>
                  }>
                  <span>パスワード</span>
                </FormLabel>
                <Input
                  className="edit_form_middle"
                  type={showPassword ? "text" : "password"} 
                  placeholder=""
                  autoComplete={"new-password"}
                  {...registerElement("password", 
                    {
                      required: "パスワードは必須項目です。",
                      pattern: {
                        value: /^(?=.*\d).{8,}$/,
                        message: "パスワードは数字を含む8文字以上の半角文字を設定してください。",
                      },
                    }
                  )} />
                  <FormErrorMessage>{ formErrors.password?.message }</FormErrorMessage>
              </FormControl>

              <Checkbox fontSize="60%" m={0} isChecked={showPassword} onChange={() => setShowPassword(!showPassword)}>パスワードを見る</Checkbox>
            </VStack>

            <FormControl><div className="edit_form_summary">新規登録時はパスワードは必須項目です。<br />数字を含む8文字以上の半角文字を設定してください。</div></FormControl>
            </>
          ) : (
            <>
            <VStack align="flex-start">
              <FormControl isInvalid={Boolean(formErrors.password)}>
                <FormLabel><span>パスワード</span></FormLabel>
                <Input
                  className="edit_form_middle"
                  type={showPassword ? "text" : "password"} 
                  placeholder=""
                  autoComplete={"new-password"}
                  {...registerElement("password", 
                    {
                      pattern: {
                        value: /^(?=.*\d).{8,}$/,
                        message: "パスワードは数字を含む8文字以上の半角文字を設定してください。",
                      },
                    }
                  )} />
                <FormErrorMessage>{ formErrors.password?.message }</FormErrorMessage>
              </FormControl>

              <Checkbox fontSize="60%" m={0} isChecked={showPassword} onChange={() => setShowPassword(!showPassword)}>パスワードを見る</Checkbox>
            </VStack>
            <FormControl ><div className="edit_form_summary">パスワードを変更する際に新しいパスワードを入力してください。<br />数字を含む8文字以上の半角文字を設定してください。</div></FormControl>
            </>
          )
        }
        </HStack>

        <Divider />

        <HStack>
          <FormControl isInvalid={ Boolean(formErrors.name) } isRequired>
            <FormLabel 
              requiredIndicator = {
                <span style={{ color: "white", fontSize: "70%", backgroundColor:"#df6694", marginLeft: "4px",}}>✱必須項目</span>
              }>
              <span>管理者名</span>
            </FormLabel>
            <Input className="edit_form_long" {...registerElement("name", {
              required: "管理者名は必須項目です。"
            })} />
            <FormErrorMessage>{ formErrors.name?.message }</FormErrorMessage>
          </FormControl>
          <FormControl >
            <div className="edit_form_summary">
            管理者名は必須項目です。
           </div>
          </FormControl>
        </HStack>

        <HStack>
          <FormControl isInvalid={ Boolean(formErrors.namePronunciation) }>
            <FormLabel><span>管理者名（かな）</span></FormLabel>
            <Input className="edit_form_long" {...registerElement("namePronunciation", {})} />
            <FormErrorMessage>{ formErrors.namePronunciation?.message }</FormErrorMessage>
          </FormControl>
        </HStack>

        <Divider />

        <FormControl isInvalid={Boolean(formErrors.note)}>
          <FormLabel><span>備考</span></FormLabel>
          <Textarea size="lg" {...registerElement("note") } />
          <FormErrorMessage>{ formErrors.note?.message }</FormErrorMessage>
        </FormControl>
 
        <Modal isOpen={isFinishOpen} onClose={onFinishClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>保存</ModalHeader>
            <ModalCloseButton />
            <ModalBody>管理者情報を保存しました。</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleOk}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
     
        <Modal isOpen={isErrorOpen} onClose={onErrorClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Error</ModalHeader>
            <ModalCloseButton />
            <ModalBody>{formError}</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={onErrorClose}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

      </VStack>
    </PageBody>
  </Page>
}
